import BaseModelAPI from '../BaseModelAPI';

export default class PartGoodReceipt extends BaseModelAPI {
	static entity = 'partgoodreceipt';
	static entityName = 'partgoodreceipt';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.purchaseOrderId = '';
		this.purchaseOrder = {};
		this.purchaseOrderNumber = '';
		this.partGoodReceiptNumber = '';
		this.partGoodReceiptDate = '';
		this.suratJalan = '';
		this.remark = '';
		this.partGoodReceiptDetail = []
		this.partGoodReceiptCase = []
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.isScanned = '';
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async printGrPdf(this_, id) {
		//const accessToken = this.useAuth ? await this_.$auth.getTokenSilently() : "";

		let _this = this_;
		//let ids = _this.$store.state.dataIds;
		return this_.$http.get(`${this.entityName}/printgrpdf/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

	static async scanPurchaseOrder(this_, qrCode) {
		let data = { "qrCode": qrCode };
		return this_.$http.post(`PartGoodReceipt/ScanPurchaseOrder`, data)
			.then(async function (response) {
				if (response != null && response.data != null) {
					return response.data;
				}
				return null;
			})
			.catch(error => {
				var stringError = 'Gagal Scan Purchase Order!';
				if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError = errorObj[0];
				}
				this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
				throw error;
			});
	}

	static async populateDetail(this_, id, qrCode) {
		let data = { "qrCode": qrCode };
		this_.$http.post('PartGoodReceipt/PopulateDetail/' + id, data
		).then(async function (response) {
			return response.data;
		}).catch(error => {
			var stringError = 'Gagal untuk memproses data!';
			if (error != null && error != undefined && error.response != null && error.response != undefined && error.response.data != null && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors != null) {
				let errorList = Object.values(error.response.data.errors);
				const errorObj = errorList.find(() => true);
				stringError = errorObj[0];
			}
			this_.toast({ message: stringError, title: 'Error', variant: 'danger' });
			throw error;
		});
	}
}